import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromActiveLanguages from "../reducers/active-languages.reducer";

// get activeLanguages state
export const getActiveLanguagesState = createSelector(
    fromFeature.getCoursesModuleState,
    // given a state of type CoursesState we return the activeLanguages state
    (state: fromFeature.CoursesState) => state.activeLanguages
);

// get the entities inside activeLanguages
export const getActiveLanguagesEntities = createSelector(
    getActiveLanguagesState,
    fromActiveLanguages.getActiveLanguagesEntities
);

// convert so our view can consume
export const getAllActiveLanguages = createSelector(
    getActiveLanguagesEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getActiveLanguagesLoaded = createSelector(
    getActiveLanguagesState,
    fromActiveLanguages.getActiveLanguagesLoaded
);

export const getActiveLanguagesLoading = createSelector(
    getActiveLanguagesState,
    fromActiveLanguages.getActiveLanguagesLoading
);
